import React, { useEffect } from 'react';

import Router from './Router';
import LangLoader from './components/LangLoader';
import Sign from './components/Sign';
import Term from './components/Term';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { useWindowSize } from './utils/utils';
import Loader from './components/Loader';
import { useLoading } from './zustand/store';

function App() {


  /* 빌드시 주석해제  */
  console = {};
  console.log = function(){};
  console.warn = function(){};
  console.error = function(){};
  window.history.scrollRestoration = 'manual';

  const { width, height } = useWindowSize();
  const { isLoading } = useLoading();

  return (
    <React.Fragment>
      <LangLoader />

      <Router />

      <Sign />
      <Term />

      <ToastContainer
        position={width > 1024 ? "bottom-right" : "bottom-center"}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        draggable
        theme={"colored"}
      />

      <Loader isLoading={isLoading} />
    </React.Fragment>
  );
}

export default App;
